import { useEffect } from 'react'
import { useRouter } from 'next/router'

export function useScrollRestoration() {
  const router = useRouter()

  useEffect(() => {
    const handleRouteChangeStart = () => {
      sessionStorage.setItem('scrollPosition', String(window.scrollY))
    }

    const handleRouteChangeComplete = () => {
      const scrollPosition = sessionStorage.getItem('scrollPosition')

      if (scrollPosition) {
        window.scrollTo(0, parseInt(scrollPosition, 10))
      }
    }

    router.events.on('routeChangeStart', handleRouteChangeStart)

    router.events.on('routeChangeComplete', handleRouteChangeComplete)

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart)

      router.events.off('routeChangeComplete', handleRouteChangeComplete)
    }
  }, [router])
}
